// src/web/routes/index.tsx
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
	beforeLoad: () => {
		// Redirect to home page (main view)
		throw redirect({ to: '/home' })
	},
})
